export const inv01_2025 = [
  {
    nombre: "Bases CAASIM-HGO-INV3-OP-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/BASES CAASIM-HGO-INV3-OP-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-01-2025.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-01-2025.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-01-2025.pdf",

            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // Do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-01-2025/FALLO CAASIM-HGO-INV3-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv02_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/BASES CAASIM-HGO-INV3-OP-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN 1 DE 2 CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/CROQUIS DE LOCALIZACIÓN 1 DE 2 CAASIM-HGO-INV3-OP-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN 2 DE 2 CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/CROQUIS DE LOCALIZACIÓN 2 DE 2 CAASIM-HGO-INV3-OP-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-02-2025/FALLO CAASIM-HGO-INV3-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

// do it for INV3-OP-03-2025
export const inv03_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-03-2025/BASES CAASIM-HGO-INV3-OP-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-03-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            jpg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-03-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-03-2025.jpg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-03-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-03-2025/PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-03-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-03-2025/",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
// do it for INV3-OP-04-2025
export const inv04_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-04-2025/BASES CAASIM-HGO-INV3-OP-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-04-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            jpg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-04-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-04-2025.jpg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-04-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-04-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-04-2025/FALLO CAASIM-HGO-INV3-OP-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv05_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-05-2025/BASES CAASIM-HGO-INV3-OP-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-05-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            jpg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-05-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-05-2025.jpg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-05-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-05-2025/PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-05-2025/FALLO CAASIM-HGO-INV3-OP-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv06_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-06-2025/BASES CAASIM-HGO-INV3-OP-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-06-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            jpg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-06-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-06-2025.jpg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-06-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-06-2025/PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-06-2025/FALLO CAASIM-HGO-INV3-OP-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv07_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-07-2025/BASES CAASIM-HGO-INV3-OP-07-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-07-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-07-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            jpg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-07-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-07-2025.jpg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-07-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-07-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-07-2025/PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-07-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-07-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-07-2025/FALLO CAASIM-HGO-INV3-04-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const inv08_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-08-2025/BASES CAASIM-HGO-INV3-OP-08-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-08-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-08-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            bak: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-08-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-08-2025.bak",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    // Do it for junta de aclaraciones
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-08-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-08-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-08-2025/PRESENTACION Y APERTURA CAASIM-HGO-INV3-OP-08-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-08-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-08-2025/FALLO CAASIM-HGO-INV3-04-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const inv_itp_01 = [
  {
    nombre:
      "BASES DE INVITACION A CUANDO MENOS 3 PROVEEDORES- SERVICIO DE AUDITORIA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/BASES DE INVITACION A CUANDO MENOS 3 PROVEEDORES- SERVICIO DE AUDITORIA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Acta de Cierre de Auditoría Externa_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Acta de Cierre de Auditoría Externa_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato Cronograma_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato Cronograma_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato de Cédula de Observaciones 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato de Cédula de Observaciones 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato de Evaluación 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato de Evaluación 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato_Carta Planeación_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato_Carta Planeación_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato_Oficio de notificación de resultados a OIC_2025_G",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato_Oficio de notificación de resultados a OIC_2025_G.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato_Oficio de notificación de resultados_ ENTE_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato_Oficio de notificación de resultados_ ENTE_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Formato_Orden de Auditoría_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Formato_Orden de Auditoría_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Modelo de Contrato 2025_s",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Modelo de Contrato 2025_s.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Observaciones _Finales_ 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Observaciones _Finales_ 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "Oficio NO SOLVENTO_ área investigadora_o_Autoridad_Competente_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Oficio NO SOLVENTO_ área investigadora_o_Autoridad_Competente_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES ITP-CAASIM-SRMYSG-SAL-012025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/JUNTA DE ACLARACIONES ITP-CAASIM-SRMYSG-SAL-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "Apertura Invitacion a Cuando Menos Tres ITP-CAASIM-SRMYSG-SAL-012025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/Apertura Invitacion a Cuando Menos Tres ITP-CAASIM-SRMYSG-SAL-012025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO ITP-CAASIM-SRMYSG-SAL-012025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-012025/ACTA DE FALLO DE INVITACION A CUANDO MENOS TRES PERSONAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv09_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-09-2025/BASES CAASIM-HGO-INV3-OP-09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-09-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-09-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-09-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-09-2025/PRESENTACIÓN Y APERTURA DE PROPO CAASIM-HGO-INV3-OP-09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-09-2025/FALLO CAASIM-HGO-INV3-OP-09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

// do the same for CAASIM-HGO-INV3-OP-10-2025

export const inv10_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-10-2025/BASES CAASIM-HGO-INV3-OP-10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-10-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-10-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-10-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-10-2025/PRESENTACIÓN Y APERTURA DE PROPO CAASIM-HGO-INV3-OP-10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-10-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-10-2025/FALLO CAASIM-HGO-INV3-OP-10-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

// do the same for CAASIM-HGO-INV3-OP-11-2025

export const inv11_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-11-2025/BASES CAASIM-HGO-INV3-OP-11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-11-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-11-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-11-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-11-2025/PRESENTACIÓN Y APERTURA DE PROPO CAASIM-HGO-INV3-OP-11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-11-2025/FALLO CAASIM-HGO-INV3-OP-11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

// do the same for CAASIM-HGO-INV3-OP-12-2025

export const inv12_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-12-2025/BASES CAASIM-HGO-INV3-OP-12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-12-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-12-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-12-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-12-2025/PRESENTACIÓN Y APERTURA DE PROPO CAASIM-HGO-INV3-OP-12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-12-2025/FALLO CAASIM-HGO-INV3-OP-12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

// do the same for CAASIM-HGO-INV3-OP-13-2025

export const inv13_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-13-2025/BASES CAASIM-HGO-INV3-OP-13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-13-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-13-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-13-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-13-2025/PRESENTACIÓN Y APERTURA DE PROPO CAASIM-HGO-INV3-OP-13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-13-2025/FALLO CAASIM-HGO-INV3-OP-13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv14_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-14-2025/BASES CAASIM-HGO-INV3-OP-14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-14-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-14-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP.14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-14-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-14-2025/APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-14-2025/FALLO CAASIM-HGO-INV3-OP-14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv15_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-15-2025/BASES CAASIM-HGO-INV3-OP-15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-15-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            dwg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-15-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-15-2025.dwg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-15-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-15-2025/APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-15-2025/FALLO CAASIM-HGO-INV3-OP-15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const inv16_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-16-2025/BASES CAASIM-HGO-INV3-OP-16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-16-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            dwg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-16-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-16-2025.dwg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-16-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-16-2025/APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  // {
  //   nombre: "FALLO CAASIM-HGO-INV3-OP-16-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-16-2025/FALLO CAASIM-HGO-INV3-OP-16-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const inv17_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-17-2025/BASES CAASIM-HGO-INV3-OP-17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-17-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            dwg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-17-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-17-2025.dwg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-17-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-17-2025/APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-17-2025/FALLO CAASIM-HGO-INV3-OP-17-2025.PDF",
            // word: "www.google.com",          },
          },
        ],
      },
    ],
  },
];

export const inv18_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-18-2025/BASES CAASIM-HGO-INV3-OP-18-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-18-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-18-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-18-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-18-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-18-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-18-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-18-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-18-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-18-2025/FALLO CAASIM-HGO-INV3-OP-18-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const inv19_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-19-2025/BASES CAASIM-HGO-INV3-OP-19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-19-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-19-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-19-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-19-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-19-2025/FALLO CAASIM-HGO-INV3-OP-19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const inv20_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-20-2025/BASES CAASIM-HGO-INV3-OP-20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-20-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-20-2025.pdf",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-20-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-20-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-20-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-INV3-OP-20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const inv21_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-21-2025/BASES CAASIM-HGO-INV3-OP-21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-21-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-21-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-21-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA CAASIM-HGO-INV3-OP-21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-21-2025/PRESENTACIÓN Y APERTURA CAASIM-HGO-INV3-OP-21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-21-2025/FALLO CAASIM-HGO-INV3-OP-21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const inv22_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-22-2025/BASES CAASIM-HGO-INV3-OP-22-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-22-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-22-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            jpg: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-22-2025/CROQUIS DE LOCALIZACION CAASIM-HGO-INV3-OP-22-2025.jpg",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-22-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-22-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA CAASIM-HGO-INV3-OP-22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-22-2025/PRESENTACIÓN Y APERTURA CAASIM-HGO-INV3-OP-22-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-22-2025/FALLO CAASIM-HGO-INV3-OP-22-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const inv23_2025 = [
  {
    nombre: "BASES CAASIM-HGO-INV3-OP-23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-23-2025/BASES CAASIM-HGO-INV3-OP-23-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-INV3-OP-23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-23-2025/CATALOGO MUDO CAASIM-HGO-INV3-OP-23-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-23-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-INV3-OP-23-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-23-2025/JUNTA DE ACLARACIONES CAASIM-HGO-INV3-OP-23-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA CAASIM-HGO-INV3-OP-23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-23-2025/PRESENTACIÓN Y APERTURA CAASIM-HGO-INV3-OP-23-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-INV3-OP-23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/CAASIM-HGO-INV3-OP-23-2025/FALLO CAASIM-HGO-INV3-OP-23-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const inv_itp_02 = [
  {
    nombre: "BASES ITP-CAASIM-SRMYSG-SAL-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-022025/BASES ITP-CAASIM-SRMYSG-SAL-02-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES INVITACION ITP-CAASIM-SRMYSG-SAL-022025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-022025/JUNTA DE ACLARACIONES INVITACION ITP-CAASIM-SRMYSG-SAL-022025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
    {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES ITP-CAASIM-SRMYSG-SAL-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/invitaciones/2025/ITP-CAASIM-SRMYSG-SAL-022025/PRESENTACIÓN Y APERTURA DE PROPOSICIONES ITP-CAASIM-SRMYSG-SAL-02-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];
